module.exports = __webpack_public_path__ + "assets/img/00138.84d247d8.png";